/**
 * useAuthState Hook
 * Passive, read-only auth state access with ZERO side effects
 *
 * Use this when you just need to read auth state without triggering
 * any session validation or API calls.
 *
 * Usage:
 * const { user, accessToken, isAuthenticated } = useAuthState();
 *
 * // Display user info
 * <span>Hello, {user?.firstName}</span>
 */

import { useAuthStore, useAccessToken } from '@/features/auth';

export function useAuthState() {
  const user = useAuthStore((state) => state.user);
  const accessToken = useAccessToken();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return {
    user,
    accessToken,
    isAuthenticated,
  };
}
